import { render, staticRenderFns } from "./FileFee.vue?vue&type=template&id=e287f3a8&"
import script from "./FileFee.vue?vue&type=script&lang=js&"
export * from "./FileFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports